export default "__VITE_ASSET__D75ju1LC__"